document.addEventListener("DOMContentLoaded", () => {

    for (const button of document.querySelectorAll(".expand-button")) {

        const expandableContainer = button.closest(".expandable-wrapper")?.querySelector(".expandable");

        if (expandableContainer) {
            button.addEventListener("click", e => toggle_shortcode_box_expand(e));
            expandableContainer.addEventListener("transitionend", e => reset_after_expand_transition(e, button));
        }

    }

});


function toggle_shortcode_box_expand(e) {

    // About this method: https://css-tricks.com/using-css-transitions-auto-dimensions/

    const button = e.currentTarget;
    // Disable the toggle button
    button.disabled = true;

    const expandableContainer = button.closest(".expandable-wrapper")?.querySelector(".expandable");

    // If the container is collapsed
    if (expandableContainer.classList.contains("expandable--collapsed")) {

        // Compute the un-collapsed height and add some pixels just to be on the safe side,
        // then set the result as the new max-height
        expandableContainer.style.maxHeight = (expandableContainer.scrollHeight + 100) + "px";

        expandableContainer.classList.remove("expandable--collapsed");

        expandableContainer.setAttribute("aria-hidden", false);

        button.classList.add("expand-button--expanded");
        button.title = button.dataset.collapse;
        button.setAttribute("aria-label", button.dataset.collapse);

    } else {

        button.classList.remove("expand-button--expanded");


        // temporarily disable all css transitions
        const savedTransition = expandableContainer.style.transition;
        expandableContainer.style.transition = '';

        requestAnimationFrame(() => {

            // Since the max-height has been set to none after expanding, we have to set a value again in order to
            // animate to the collapsed max-height.
            expandableContainer.style.maxHeight = expandableContainer.scrollHeight + "px";
            expandableContainer.style.transition = savedTransition;

            // We can't use this value immediately, so we have to wait until the browser has applied the style
            // and is ready for the next steps.
            requestAnimationFrame(() => {

                // Max height is set to 0 in the regular stylesheet
                expandableContainer.style.maxHeight = null;

                expandableContainer.setAttribute("aria-hidden", true);

                expandableContainer.classList.add("expandable--collapsed");

                button.title = button.dataset.expand;
                button.setAttribute("aria-label", button.dataset.ariaExpand);

            });

        });


    }

}

function reset_after_expand_transition(e, button) {

    // If some other animation is bubbling up (e.g. the button rotation), ignore it and return.
    // (Assume that there is no other max-height transition.)
    if (e.propertyName !== "max-height") {
        return;
    }

    const expandableContainer = e.currentTarget;

    // enable the toggle button again
    button.disabled = false;

    // If the container just has expanded, set the max-height to none
    // so all will be visible even if e.g. the height changes.
    if (!expandableContainer.classList.contains("expandable--collapsed")) {
        expandableContainer.style.maxHeight = "none";
    }

}
